import React from 'react';
import './progressBlock.styles.scss';
import {
	ProgressCircle,
	ProgressCircleProps,
} from '../base/progress-circle/ProgressCircle';
import { CONSTANTS } from '../../utils';

interface ProgressBlockProps extends ProgressCircleProps {
	wrapperClass?: string;
	title: string;
}

export const ProgressBlock = ({
	total,
	used,
	size = 60,
	wrapperClass = '',
	title,
}: ProgressBlockProps) => {
	return (
		<div className={`progress-block ${wrapperClass}`}>
			<ProgressCircle total={total} used={used} size={size} />
			<div className="progress-block__details">
				<p className="progress-block__title">{title}</p>
				<p className="progress-block__data">
					<span className="progress-block__data-used">
						{typeof used === 'number' ? used : CONSTANTS.noData}
					</span>
					&nbsp;/&nbsp;
					<span className="progress-block__data-total">
						{typeof total === 'number' ? total : CONSTANTS.noData}
					</span>
				</p>
			</div>
		</div>
	);
};
